import StvPage from "./StvPage";

export default class AppCtxBo {
    currentPage: StvPage = StvPage.HOMEPAGE_FACELIFT;
    renderMainKontakt = false;
    /** Steuert, welche Version der Benutzer zu sehen bekommt. Hat bisher nur Auswirkungen auf die Homepage. */
    abTestVersion: 'a'|'b'|'c' = 'b';
    
    constructor(abtestVersion?:string) {
        if (abtestVersion &&  abtestVersion === 'a') {
            this.abTestVersion = 'a';
            this.currentPage = StvPage.HOMEPAGE;
        } else if (abtestVersion &&  abtestVersion === 'c'){
            // DOGORAMA
            this.abTestVersion = 'c';
            this.currentPage = StvPage.HOMEPAGE_DOGORAMA;
        } else {
            // default
            this.abTestVersion = 'b';
            this.currentPage = StvPage.HOMEPAGE_FACELIFT;
        }
    }
}